import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d1503106"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "BottomBar"
};
var _hoisted_2 = {
  "class": "BottomBar__icon-container"
};
var _hoisted_3 = {
  key: 0,
  "class": "AppsBar"
};
var _hoisted_4 = {
  key: 1,
  "class": "walkthrough-pointer"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_8 = [_hoisted_5, _hoisted_6, _hoisted_7];
var _hoisted_9 = {
  key: 0,
  "class": "walkthrough-pointer"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_13 = [_hoisted_10, _hoisted_11, _hoisted_12];
var _hoisted_14 = {
  key: 0,
  "class": "walkthrough-pointer"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_18 = [_hoisted_15, _hoisted_16, _hoisted_17];
var _hoisted_19 = {
  key: 0,
  "class": "walkthrough-pointer"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_23 = [_hoisted_20, _hoisted_21, _hoisted_22];
var _hoisted_24 = {
  key: 0,
  "class": "SettingsMenu__container"
};
var _hoisted_25 = {
  key: 1,
  "class": "walkthrough-pointer"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ripple"
  }, null, -1);
});
var _hoisted_29 = [_hoisted_26, _hoisted_27, _hoisted_28];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    "class": "BottomBar__icon-holder",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.showAppsAction();
    })
  }, [$data.showApps ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
    "class": "BottomBar__icon-holder-apps",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      _this.showApps = false;
      _ctx.$store.commit('updateShowToDoList', true);
      _ctx.$store.commit('updateShowNotes', false);
      _ctx.$store.commit('updateUseAudio', true);
      _ctx.$store.commit('voiceOn');
      _ctx.$store.dispatch('buzzPhone');
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-list-check",
    size: "2xl",
    "class": _normalizeClass({
      'BottomBar__icon-app': true,
      'BottomBar__icon--active-app': _ctx.$store.state.showToDoList,
      'BottomBar__icon--active-map': _ctx.$store.state.showToDoList
    })
  }, null, 8, ["class"]), _createElementVNode("div", {
    id: "bottomLinktodo",
    "class": _normalizeClass({
      'BottomBar__icon-label-app': true,
      'BottomBar__icon-label--inactive-app': !_ctx.$store.state.showToDoList
    })
  }, " ToDo ", 2)]), _createElementVNode("div", {
    "class": "BottomBar__icon-holder-apps",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      _this.showApps = false;
      _ctx.$store.commit('updateShowNotes', true);
      _ctx.$store.commit('updateShowToDoList', false);
      _ctx.$store.dispatch('buzzPhone');
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-book",
    size: "2xl",
    "class": _normalizeClass({
      'BottomBar__icon-app': true,
      'BottomBar__icon--active-app': _ctx.$store.state.showNotes,
      'BottomBar__icon--active-notes': _ctx.$store.state.showNotes
    })
  }, null, 8, ["class"]), _createElementVNode("div", {
    id: "bottomLinkNotes",
    "class": _normalizeClass({
      'BottomBar__icon-label-app': true,
      'BottomBar__icon-label--inactive-app': !_ctx.$store.state.showNotes
    })
  }, " Notes ", 2)])])) : _createCommentVNode("", true), _ctx.$store.state.TutorialPointerApps ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8)) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'grid-2'],
    size: "2xl",
    "class": _normalizeClass({
      BottomBar__icon: true,
      'BottomBar__icon--active-apps': $data.showApps,
      'BottomBar__icon--active': $data.showApps
    })
  }, null, 8, ["class"]), _createElementVNode("div", {
    id: "bottomLinkVideo",
    "class": _normalizeClass({
      'BottomBar__icon-label': true,
      'BottomBar__icon-label--inactive': !$data.showApps
    })
  }, " Apps ", 2)]), _createElementVNode("div", {
    "class": "BottomBar__icon-holder",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      _ctx.$store.dispatch('showViewVideo');
      _ctx.$store.dispatch('buzzPhone');
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'image-polaroid-user'],
    size: "2xl",
    "class": _normalizeClass({
      BottomBar__icon: true,
      'BottomBar__icon--active-video': !_ctx.$store.state.ShowAvatarSettings && !_ctx.$store.state.showAudioView && !_ctx.$store.state.showCalls && !_ctx.$store.state.showMap && !_ctx.$store.state.showChatHistory && !_ctx.$store.state.showNotes && !_ctx.$store.state.showToDoList,
      'BottomBar__icon--active': !_ctx.$store.state.ShowAvatarSettings && !_ctx.$store.state.showAudioView && !_ctx.$store.state.showCalls && !_ctx.$store.state.showMap && !_ctx.$store.state.showChatHistory && !_ctx.$store.state.showNotes && !_ctx.$store.state.showToDoList
    })
  }, null, 8, ["class"]), _ctx.$store.state.TutorialPointerVideo ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("div", {
    id: "bottomLinkVideo",
    "class": _normalizeClass({
      'BottomBar__icon-label': true,
      'BottomBar__icon-label--inactive': _ctx.$store.state.showAudioView || _ctx.$store.state.showMap || _ctx.$store.state.showChatHistory || _ctx.$store.state.showNotes || _ctx.$store.state.showToDoList || _ctx.$store.state.showCalls || _ctx.$store.state.ShowAvatarSettings
    })
  }, " Video ", 2)]), _createElementVNode("div", {
    "class": "BottomBar__icon-holder",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      _ctx.$store.dispatch('showViewText');
      _ctx.$store.dispatch('buzzPhone');
    })
  }, [_ctx.$store.state.TutorialPointerChat ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_18)) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'message'],
    size: "2xl",
    "class": _normalizeClass({
      BottomBar__icon: true,
      'BottomBar__icon--active': _ctx.$store.state.showChatHistory,
      'BottomBar__icon--active-chat': _ctx.$store.state.showChatHistory
    })
  }, null, 8, ["class"]), _createElementVNode("div", {
    id: "bottomLinkText",
    "class": _normalizeClass({
      'BottomBar__icon-label': true,
      'BottomBar__icon-label--inactive': !_ctx.$store.state.showChatHistory
    })
  }, " Text ", 2)]), _createElementVNode("div", {
    "class": "BottomBar__icon-holder",
    onClick: _cache[5] || (_cache[5] = function ($event) {
      _ctx.$store.dispatch('showViewMap');
      _ctx.$store.dispatch('buzzPhone');
    })
  }, [_ctx.$store.state.TutorialPointerMap ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23)) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'map-location-dot'],
    size: "2xl",
    "class": _normalizeClass({
      BottomBar__icon: true,
      'BottomBar__icon--active': _ctx.$store.state.showMap,
      'BottomBar__icon--active-map': _ctx.$store.state.showMap
    })
  }, null, 8, ["class"]), _createElementVNode("div", {
    id: "bottomLinkMap",
    "class": _normalizeClass({
      'BottomBar__icon-label': true,
      'BottomBar__icon-label--inactive': !_ctx.$store.state.showMap
    })
  }, " Map ", 2)]), _createElementVNode("div", {
    "class": "BottomBar__icon-holder",
    onClick: _cache[11] || (_cache[11] = function ($event) {
      _ctx.$store.commit('updateShowAIVitarSettingsMenu', !_ctx.$store.state.showAIVitarSettingsMenu);
      _ctx.$store.dispatch('buzzPhone');
    })
  }, [_ctx.$store.state.showAIVitarSettingsMenu ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", {
    "class": "SettingsMenu__item",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      _ctx.$store.commit('updatePreventIntroExperience', true);
      _ctx.$store.dispatch('closeAllViews');
      _ctx.$store.commit('updateSingleIntroSave', true);
      _ctx.$store.commit('startIntroPage', 'Gallery');
    })
  }, " Select a New AIVitar "), _createElementVNode("div", {
    "class": "SettingsMenu__item",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      _ctx.$store.commit('updatePreventIntroExperience', true);
      _ctx.$store.dispatch('closeAllViews');
      _ctx.$store.commit('updateSingleIntroSave', true);
      _ctx.$store.commit('startIntroPage', 'Voice');
    })
  }, " Change My AIVitar's Voice "), _createElementVNode("div", {
    "class": "SettingsMenu__item",
    onClick: _cache[8] || (_cache[8] = function ($event) {
      _ctx.$store.commit('updatePreventIntroExperience', true);
      _ctx.$store.dispatch('closeAllViews');
      _ctx.$store.commit('updateSingleIntroSave', true);
      _ctx.$store.commit('startIntroPage', 'Personality');
    })
  }, " Change My AIVitar's Personality "), _createElementVNode("div", {
    "class": "SettingsMenu__item",
    onClick: _cache[9] || (_cache[9] = function ($event) {
      _ctx.$store.commit('updatePreventIntroExperience', true);
      _ctx.$store.dispatch('closeAllViews');
      _ctx.$store.commit('updateSingleIntroSave', false);
      _ctx.$store.commit('startIntroPage', 'CompanionPreference');
    })
  }, " Choose a Different Gender "), _createElementVNode("div", {
    "class": "SettingsMenu__item",
    onClick: _cache[10] || (_cache[10] = function ($event) {
      _ctx.$store.commit('updatePreventIntroExperience', true);
      _ctx.$store.dispatch('closeAllViews');
      _ctx.$store.dispatch('showViewUserSettings');
      _ctx.$store.dispatch('buzzPhone');
    })
  }, " View AIVitar Features ")])) : _createCommentVNode("", true), _ctx.$store.state.TutorialPointerAvatar ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_29)) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fa', 'user'],
    size: "2xl",
    "class": _normalizeClass({
      BottomBar__icon: true,
      'BottomBar__icon--active': _ctx.$store.state.showAIVitarSettingsMenu,
      'BottomBar__icon--active-map': _ctx.$store.state.ShowAvatarSettings
    })
  }, null, 8, ["class"]), _createElementVNode("div", {
    id: "bottomLinkMap",
    "class": _normalizeClass({
      'BottomBar__icon-label': true,
      'BottomBar__icon-label--inactive': !_ctx.$store.state.ShowAvatarSettings
    })
  }, " Settings ", 2)])])]);
}